import { TReduxActions } from '../../../../shared/types/redux';
import { IBedroom, IBedroomAction } from '../../../../shared/types/filters/bedroom';

export const BEDROOM_UPDATE = 'search/BEDROOM_UPDATE';

const initialState: IBedroom = {
  bedroom: undefined,
  isDirty: false,
};

export const bedroomReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case BEDROOM_UPDATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};

export const setBedroom = (bedroom: string): IBedroomAction => {
  return {
    type: BEDROOM_UPDATE,
    payload: {
      bedroom,
    },
  };
};

export const setDirty = (isDirty: boolean): IBedroomAction => {
  return {
    type: BEDROOM_UPDATE,
    payload: {
      isDirty,
    },
  };
};
